import universalDesignSystem from '@/config/colorPallets/universalDesignSystem';
import CollectionOptionFields from '@/components/Editor/Form/fields/CollectionOption';
import { DISABLED_POINT_STYLES } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";
export function generateCollectionSettings(_ref) {
  let {
    component
  } = _ref;
  const defaultProps = {
    Bubble: {
      hasPointRadius: false
    }
  }[component];
  return {
    title: 'Category',
    defaultProps,
    selectionsLabeled: false
  };
}

const WidgetEditFormPointChartCollectionOption = _ref2 => {
  let {
    nameSpace,
    collectionIndex,
    collectionOption,
    colorPallet,
    hasPointRadius,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(CollectionOptionFields, {
    namePrefix: nameSpace,
    index: collectionIndex,
    config: collectionOption,
    singleLabel: false,
    colored: true,
    hasTrendline: true,
    hasDataLabels: true,
    hasPointStyles: true,
    hasPointRadius: hasPointRadius,
    defaultValues: {
      color: colorPallet[collectionIndex],
      trendlineBorderColor: universalDesignSystem.gray20
    },
    labels: {
      trendline: {
        borderFieldsLegend: 'Line',
        clearBorder: 'Clear Line',
        colorPickerLabel: 'Optional line color'
      }
    },
    disabledPointStyles: DISABLED_POINT_STYLES,
    onChange: onChange
  });
};

export default WidgetEditFormPointChartCollectionOption;